import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param orgId
 */
class TdsTcsService {
  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  createTdsTcs = async (payload) => {
    const createdTdsTcs = await Helpers.post({
      url: Constants.TDS_TCS,
      data: payload,
    });
    return createdTdsTcs;
  };

  /**
   * @param taxName
   * @return {Promise<*>}
   */
  getTdsTcs = async (page, limit) => {
    let url = `${Constants.TDS_TCS}?tax_name=TDS,TCS&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    const taxes = await Helpers.get({ url });
    return taxes;
  };

  /**
   * @param taxName
   * @return {Promise<*>}
   */
  getDefaultTdsTcs = async (taxName) => {
    let url = `${Constants.TDS_TCS}/taxes?`;
    if (taxName) url += `tax_name=${taxName}&`;
    const taxes = await Helpers.get({ url });
    return taxes;
  };

  /**
   * @param payload
   * @return {Promise<*>}
   */
  updateTdsTcs = async (payload) => {
    const updatedTdsTcs = await Helpers.put({
      url: Constants.TDS_TCS,
      data: payload,
    });
    return updatedTdsTcs;
  };

  /**
   * @param payload
   * @return {Promise<*>}
   */
  deleteTdsTcs = async (payload) => {
    const deletedTdsTcs = await Helpers.delete({
      url: Constants.TDS_TCS,
      data: payload,
    });
    return deletedTdsTcs;
  };
}
export default new TdsTcsService();
